var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMessageRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  width: "1em",
  height: "1em",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M41.25 40c0-2.07 1.68-3.75 3.75-3.75h30a3.751 3.751 0 0 1 0 7.5H45A3.75 3.75 0 0 1 41.25 40m-20 20A3.75 3.75 0 0 0 25 63.75h30a3.751 3.751 0 0 0 0-7.5H25c-2.07 0-3.75 1.68-3.75 3.75M11.3 81.663A49.8 49.8 0 0 1 0 50C0 22.386 22.386 0 50 0s50 22.386 50 50-22.386 50-50 50H6.134c-4.314 0-6.603-5.097-3.737-8.322zM50 92.5c23.472 0 42.5-19.028 42.5-42.5S73.472 7.5 50 7.5 7.5 26.528 7.5 50a42.3 42.3 0 0 0 9.602 26.91 7.5 7.5 0 0 1-.196 9.735L11.701 92.5z"
})));
export default SvgIconMessageRight;